import { 
  Module as m, 
  createModule as createM,
} from './module'
import i from './init'
import * as statusConstants from './constants'


export const createModule = createM
export const Module = m
export const init  = i
export const constants = statusConstants



// WEBPACK FOOTER //
// ./src/modules/redux-acron/index.js